<template>
  <div class="orders-scheduler-calendar">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
      "
    >
      <b-field grouped>
        <b-field label="Scheduled Log">
          <b-select v-model="filters.scheduled_log_id" name="select_scheduled_log">
            <option value>Please Select</option>
            <option
              v-for="(scheduledLog, index) in scheduledLogs"
              :value="scheduledLog.id"
              :key="index"
            >
              {{ scheduledLog.id }} -
              {{ scheduledLog.createdAt | toLocalDateAndTime }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Order">
          <b-select v-model="filters.order_id">
            <option value>Please Select</option>
            <option
              v-for="(orderId, index) in orderIds"
              :value="orderId"
              :key="index"
            >
              {{ orderId }}
            </option>
          </b-select>
        </b-field>
      </b-field>

      <b-button
        type="is-light"
        @click="mode = mode == 'CALENDAR' ? 'LIST' : 'CALENDAR'"
      >
        {{ mode == "CALENDAR" ? "LIST" : "CALENDAR" }}
      </b-button>
    </div>

    <calendar-view
      v-show="mode === 'CALENDAR'"
      :items="calendarItems"
      :show-date="calendarShowDate"
      currentPeriodLabel="Today" 
      class="operations-calendar theme-gcal"
    >
      <calendar-view-header
        slot="header"
        slot-scope="t"
        :header-props="t.headerProps"
        @input="(v) => (calendarShowDate = v)"
      />

      <template #item="{ value }">
        <div
          :class="['cv-item', ...value.classes].join(' ')"
          :style="`top: calc(${2.5 + (value.itemRow * 2)}em + ${
            6 * value.itemRow
          }px);`"
          @click="onCalendarItemClick(value)"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span>{{ value.title }}</span>
            <b-icon
              icon="info-circle"
              :title="getCalendarItemTooltip(value.originalItem)"
            />
          </div>
        </div>
      </template>
    </calendar-view>

    <div v-show="mode === 'LIST'">
      <b-table
        v-show="mode === 'LIST'"
        :data="operationsFiltered"
        sticky-header
        class="operations-list"
      >
        <template slot-scope="props">
          <b-table-column field="order" label="Order">
            <b-button type="is-text" @click="viewOrder(props.row.order.id)">
              {{ props.row.order.id }}
            </b-button>
          </b-table-column>

          <b-table-column field="name" label="Operation">
            {{ props.row.operationId }}
          </b-table-column>

          <b-table-column field="date" label="Date">
            {{ props.row.requiredFinish | toLocalDate }}
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
// import "vue-simple-calendar/static/css/default.css";
import "@/assets/calendar/gcal.css";
import { DateFormat } from "@/helpers/date-format";

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
  },
  props: {
    operations: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    filters: {
      scheduled_log_id: "",
      order_id: "",
    },
    mode: "CALENDAR",
    calendarItems: [],
    calendarShowDate: new Date(),
  }),
  computed: {
    scheduledLogs() {
      const logs = [];
      this.operations.forEach((op) => {
        if (!logs.find((l) => l.id == op.order.scheduledLog.id)) {
          logs.push(op.order.scheduledLog);
        }
      });
      return logs;
    },
    orderIds() {
      const orderIds = [];
      this.operations.forEach((op) => {
        if (!orderIds.includes(op.orderId)) {
          orderIds.push(op.orderId);
        }
      });
      return orderIds;
    },
    operationsFiltered() {
      if (this.filters.scheduled_log_id || this.filters.order_id) {
        return this.operations.filter((op) => {
          return (
            (this.filters.scheduled_log_id
              ? op.order.scheduledLog.id == this.filters.scheduled_log_id
              : true) &&
            (this.filters.order_id ? op.orderId == this.filters.order_id : true)
          );
        });
      } else {
        return this.operations;
      }
    },
  },
  watch: {
    operations() {
      this.generateCalendarItems();
    },
    calendarShowDate() {
      this.generateCalendarItems();
    },
    filters: {
      handler: function () {
        this.$nextTick(() => {
          this.generateCalendarItems();
        });
      },
      deep: true,
    },
  },
  methods: {
    generateCalendarItems() {
      const monthStart = moment(this.calendarShowDate).startOf("month");
      const monthEnd = moment(this.calendarShowDate).endOf("month");
      this.calendarItems = this.operationsFiltered.reduce((acc, v) => {
        if (v.requiredFinish) {
          const operationDate = moment(v.requiredFinish);
          if (
            operationDate.isSameOrAfter(monthStart) &&
            operationDate.isSameOrBefore(monthEnd)
          ) {
            acc.push({
              id: v.id,
              startDate: v.requiredFinish,
              // title: `${v.order.id} - ${v.operationId} - ${v.activityCode.name}`,
              title: v.operationId,
              order: {
                id: v.order.id,
                scheduledLog: {
                  createdAt: v.order.scheduledLog.createdAt,
                },
              },
            });
          }
        }
        return acc;
      }, []);
    },
    getCalendarItemTooltip(item) {
      return `Date generated: ${DateFormat.toLocalDateAndTime(
        item.order.scheduledLog.createdAt
      )}\nOrder: ${item.order.id}`;
    },
    viewOrder(orderId) {
      this.$router.push({ name: "order-list", query: { id: orderId } });
    },
    onCalendarItemClick(item) {
      this.viewOrder(item.originalItem.order.id);
    },
  },
};
</script>

<style lang="scss">
.operations-calendar {
  height: 65vh !important;
}
.operations-list {
  .table-wrapper {
    height: 65vh !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/OrdersScheduler/calendar/index.vue